import api from './api';

const resource = 'Finance/';

export const list = async (query) => {
  return await api.get(resource + 'List' + query);
};

export const getById = async (query) => {
  return await api.get(resource + 'Get' + query);
};

export const getBalanceById = async (companyId) => {
  return await api.get(resource + 'GetBalance?companyid=' + companyId);
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

// Finance/List/Type pages server-side and falls back to the first 10 rows
// ordered by name descending, so the caller's query is the only thing that
// reaches page two — or reaches a type that is not in those ten. Screens that
// want the whole set for a picker pass `?pageSize=1000`, the same way the
// company picker next to them does.
export const getTypeList = async (query = '') => {
  return await api.get(resource + 'List/Type' + query);
};

export const getTypeById = async (id) => {
  return await api.get(resource + 'GetType?id=' + id);
};

export const upsertType = async (body) => {
  return await api.post(resource + 'UpsertType', body);
};

export const deleteTypeById = async (id) => {
  return await api.delete(resource + 'DeleteType?id=' + id);
};

export const pay = async (companyid) => {
  return await api.post(resource + 'Pay?companyid=' + companyid);
};

const financeApi = {
  list,
  getById,
  getBalanceById,
  upsert,
  deleteById,
  getTypeList,
  getTypeById,
  upsertType,
  deleteTypeById,
  pay,
};

export default financeApi;
